<template>
  <div>
    <el-card class="mb5">
      <el-form
        ref="searchForm" v-model="queryForm" :inline="false"
        label-position="top"
      >
        <el-row :gutter="10">
          <el-col :span="4">
            <el-form-item size="small">
              <template slot="label">
                <el-select
                  v-model="queryForm.params.searchNumberType"
                  :placeholder="$t('orderDetails.pleaseChoose')"
                  :style="IsWidth"
                  class="selectClass"
                  size="small"
                  @change="handleChangeLable"
                >
                  <!--运单号-->
                  <el-option key="1" :label="$t('orderCenterCont.anjunWaybillNumber')" value="1" />
                  <!--扫描单号-->
                  <el-option key="8" :label="$t('GlobalSetObj.ScanNumber')" value="8" />
                  <!-- 安骏订单号 -->
                  <el-option key="15" :label="$t('GlobalSetObj.anJunOrderNumber')" value="15" />
                  <!--客户订单号-->
                  <el-option key="2" :label="$t('newOrder.PlatformOrderNumber')" value="2" />
                  <!--中转仓袋号-->
                  <el-option key="4" :label="$t('orderCenterCont.TransitBinBagNumber')" value="4" />
                  <!--子包号-->
                  <el-option key="7" :label="$t('orderCenterCont.SubpackageNumber')" value="7" />
                </el-select>
              </template>
              <el-input
                v-model="searchNumberStr"
                :placeholder="$t('newOrder.PreciseSearch1')"
                :rows="2"
                style="margin-top: 3px"
                type="textarea"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--创建时间-->
            <el-form-item prop="searchTimeType" size="small">
              <template slot="label">
                <el-select
                  v-model="queryForm.params.searchTimeType"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  :style="IsWidthTime"
                  class="selectClass"
                >
                  <!--创建时间-->
                  <el-option key="1" :label="$t('newOrder.createTime')" value="1" />
                  <!--客户出仓时间-->
                  <el-option key="5" :label="$t('orderCenterCont.customerDeliveryTime')" value="5" />
                  <!--转运入库时间-->
                  <el-option key="3" :label="$t('newOrder.TransitInboundTime')" value="3" />
                  <!--转运出库时间-->
                  <el-option key="4" :label="$t('newOrder.shipmentTime')" value="4" />
                  <!--网点派件时间-->
                  <el-option key="7" :label="$t('orderCenterCont.deliveryTime')" value="7" />
                  <!--签收时间-->
                  <el-option key="2" :label="$t('orderCenterCont.SigningTime')" value="2" />
                </el-select>
              </template>
              <el-date-picker
                v-model="timeValue"
                :default-time="['00:00:00', '23:59:59']"
                :end-placeholder="$t('operationCenter.endDate')"
                :format="$i18n.locale === 'zh' ? zhDate : ptDate"
                :picker-options="pickerOptions"
                :start-placeholder="$t('operationCenter.startDate')"
                range-separator="~"
                size="small"
                style="width: 100%; margin-top: 3px"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                @change="handleTime"
                @input="changeInput($event)"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <!--客户-->
            <el-form-item :label="$t('newOrder.CustomerName')">
              <el-select
                v-model="queryForm.params.customerIds"
                :placeholder="$t('GlobalSetObj.OnlyAreDisplayed')"
                :remote-method="getCustomerPage"
                clearable
                filterable
                multiple
                remote
                reserve-keyword
                size="small"
                style="width: 100%"
                @clear="getCustomerPage('')"
                @focus="getCustomerPageFuc"
              >
                <el-option
                  v-for="item in customerList"
                  :key="item.id"
                  :label="item.customerAlias + '(' + item.username + ')'"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <div style="margin-top: 28px">
              <!--搜索-->
              <el-button
                size="small" type="primary" @click="searchFun"
              >{{ $t('newOrder.search') }}
              </el-button>
              <!--清空当前内容-->
              <el-button
                size="small" style="margin-left: 10px" type="info"
                @click="resetForm"
              >
                {{ $t('customerManagements.reset') }}
              </el-button>
              <!--自定义显示列-->
              <el-tooltip
                :content="$t('orderCenterCont.customizingDisplayColumns')"
                class="item"
                effect="dark"
                placement="top"
              >
                <el-button
                  icon="el-icon-setting"
                  style="font-size: 24px; color: #333"
                  type="text"
                  @click="operationTableDialog"
                />
              </el-tooltip>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card>
      <el-dropdown size="small" trigger="click">
        <el-button
          size="small" type="primary"
        >{{ $t('navbar.export') }}<i
          class="el-icon-arrow-down el-icon--right"
        /></el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <el-button
              size="small"
              style="margin-bottom: 2px"
              type="success"
              @click="allExportOrder"
            >{{ $t('collectionCenter.allExport') }}
            </el-button>
          </el-dropdown-item>
          <el-dropdown-item>
            <!--勾选导出-->
            <el-button
              size="small"
              style="margin-bottom: 2px"
              type="success"
              @click="exportOrder"
            >{{ $t('collectionCenter.export1') }}
            </el-button>
          </el-dropdown-item>
          <el-dropdown-item>
            <!--批量单号导出-->
            <el-button
              size="small"
              style="margin-bottom: 2px"
              type="success"
              @click="orderNumberExport"
            >{{ $t('placeOrder.BatchExport') }}
            </el-button>
          </el-dropdown-item>
          <el-dropdown-item>
            <!--导出子包信息-->
            <el-button
              size="small"
              type="success"
              @click="exportOrderChilder"
            >{{ $t('collectionCenter.exportChilderInfor') }}
            </el-button>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-radio-group v-model="dataType" size="small" style="margin-left: 10px">
        <el-radio-button :label="1">{{ $t('newOrder.Formal') }}</el-radio-button>
        <el-radio-button :label="2">{{ $t('newOrder.test1') }}</el-radio-button>
      </el-radio-group>
      <el-divider />
      <!--  表格数据  -->
      <template>
        <AnjunTableList
          ref="anjunTable"
          :format-time="isTormat"
          :has-operation="true"
          :header-list="tableHeaderList"
          :hide="false"
          :is-index="true"
          :is-select-btn="true"
          :is-tip="true"
          :table-data="tableData"
          class="table_color_class"
          @on-checkTrajectory="trajectoryQuery"
          @selectTable="selectTable"
        >
          <template #waybillNumber="{ row }">
            <el-popover placement="top" popper-class="copy" trigger="hover">
              <el-button
                v-if="row.waybillNumber" style="color: black; font-size: 12px; padding: 2px"
                type="text"
                @click="copy(row.waybillNumber)"
              >
                {{ $t('orderDetails.copy') }}
              </el-button>
              <div
                slot="reference"
                class="waybill-number-link"
                @click="handleClick(row)"
              >
                {{ row.waybillNumber || '- -' }}
              </div>
            </el-popover>
          </template>
        </AnjunTableList>
      </template>
      <!--  分页  -->
      <el-pagination
        :current-page.sync="queryForm.number"
        :page-size.sync="queryForm.pageSize"
        :page-sizes="[10, 50, 100, 200, 400]"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: 20px 0; text-align: right"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>

    <!--自定义显示列-->
    <el-dialog
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('seller.customTableDisplayList')"
      :visible.sync="isoperationTable"
      :width="`${$i18n.locale === 'zh' ? '30%' : '45%'}`"
    >
      <el-form ref="tableHeaderForm" :model="tableHeaderForm" label-width="auto">
        <el-form-item label="">
          <div style="font-size: 18px">{{ $t('GlobalSetObj.HideTheColumn') }}</div>
        </el-form-item>
        <el-form-item label="">
          <el-checkbox-group v-model="tableHeaderForm.tableHeaderList">
            <el-row :gutter="0" style="display: flex; flex-flow: wrap">
              <el-col v-for="item in bindTableColumns" :key="item.id" :span="8">
                <div style="width: 140px; word-wrap: break-word; word-break: break-all">
                  <el-checkbox :label="item.label" />
                </div>
              </el-col>
            </el-row>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="float: left" @click="resetTable">
          {{ $t('GlobalSetObj.reset') }}
        </el-button>
        <el-button @click="isoperationTable = false">{{ $t('GlobalSetObj.Cancelar') }}</el-button>
        <el-button type="primary" @click="operationTable">
          {{ $t('GlobalSetObj.confirm') }}
        </el-button>
      </span>
    </el-dialog>

    <!--批量导出-->
    <orderNumberExport ref="OrderExport" />

    <!--运单详情-->
    <el-drawer
      :append-to-body="true"
      :title="$t('orderCenterCont.archivedOrders')"
      :visible.sync="waybillVisible"
      custom-class="drawerClass"
      direction="ltr"
      size="90%"
    >
      <div style="height: calc(100vh - 67px); overflow: auto">
        <waybill-archived
          :key="showQueryTrack.trackKey"
          :query-track-param="TrackParam"
          query-type="1"
        />
      </div>
    </el-drawer>

    <!--轨迹-->
    <el-drawer
      :append-to-body="true"
      :title="$t('orderCenterCont.TrajectoryQuery')"
      :visible.sync="showQueryTrack.visible"
      custom-class="drawerClass"
      direction="ltr"
      size="80%"
    >
      <div style="height: calc(100vh - 67px); overflow: auto">
        <trackQuery
          :key="showQueryTrack.trackKey"
          :query-track-param="queryTrackParam"
          query-type="1"
        />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import {
  archiveQueryPage, archiveWaybillExportAll, subpackageExportAll
} from '@/api/logisticsOrders/index.js';
import { commonDesensitize } from '@/utils/desensitization';
import { headerList, tableHeaderForm } from '@/utils/enumData';
import AnjunTableList from '@/components/anjun-tableList';
import { cloneDeep } from 'lodash-es';
import { goRWExportList } from '@/utils/goExportList';
import orderNumberExport from './orderNumberExport.vue';
import { copyData } from '@/utils/copyData';
import waybillArchived from '@/views/orderCenter/expressAndlargOrder/component/waybillArchived.vue';
import { apiCustomerPage } from '@/api/customer';
import trackQuery from '@/views/orderCenter/expressAndlargOrder/component/trackQuery.vue';

export default {
  name: 'LogisticsOrder',
  components: {
    trackQuery,
    waybillArchived,
    orderNumberExport,
    AnjunTableList
  },
  data() {
    return {
      customerList: [], // 客户列表
      waybillVisible: false,
      showQueryTrack: {
        visible: false,
        trackKey: new Date().getTime()
      },
      queryTrackParam: {}, // 轨迹详情
      TrackParam: {},
      SubpackageParam: {},
      dataType: 1,
      isoperationTable: false,
      queryForm: {
        pageSize: 10,
        number: 1,
        params: {
          searchNumberType: '1',
          searchTimeType: '1',
          customerIds: []
        }
      },
      searchNumberStr: '',
      searchNumberList: [],
      timeValue: [],
      zhDate: 'yyyy-MM-dd HH:mm:ss',
      ptDate: 'dd-MM-yyyy HH:mm:ss',
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime();
          if (maxDate) {
            this.selectDate = '';
          }
        },
        disabledDate: (time) => {
          if (this.selectDate !== '') {
            const one = 30 * 24 * 3600 * 1000;
            const minTime = this.selectDate - one;
            const maxTime = this.selectDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        }
      },
      searchNameObj: { id: 1, label: this.$t('newOrder.waybillNumber'), value: 1 },
      // 查询列表数据
      selectLabel: [
        { id: 1, label: this.$t('newOrder.waybillNumber'), value: 1 },
        { id: 2, label: this.$t('newOrder.PlatformOrderNumber'), value: 2 },
        { id: 4, label: this.$t('orderCenterCont.TransitBinBagNumber'), value: 4 },
        { id: 5, label: this.$t('GlobalSetObj.serviceLogistics'), value: 5 },
        { id: 7, label: this.$t('orderCenterCont.SubpackageNumber'), value: 7 }
      ],
      total: 0,
      tableData: [],
      // 是否格式化成巴西时间
      isTormat: false,
      tableHeaderForm: {
        tableHeaderList: tableHeaderForm
      },
      tableHeaderList: headerList,
      // 勾选表格数据
      selectionList: [],
      bindTableColumns: headerList
    };
  },
  computed: {
    IsWidth() {
      return {
        width: this.isTormat ? '250px' : '130px'
      };
    },
    IsWidthTime() {
      return {
        width: this.isTormat ? '200px' : '150px'
      };
    }
  },
  created() {
    if (this.$i18n.locale !== 'zh') {
      this.isTormat = true;
    }
    this.getTimer();
    this.searchFun();
  },
  beforeDestroy() {
    if (this.realTimeTimer) {
      clearInterval(this.realTimeTimer);
    }
  },
  methods: {
    getCustomerPageFuc() {
      if (this.customerList.length === 0) {
        this.getCustomerPage('');
      }
    },
    getCustomerPage(name) {
      const param = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          quickSearch: name
        }
      };
      apiCustomerPage(param).then((res) => {
        if (res.code === 200) {
          this.customerList = res.data.records;
        }
      });
    },
    // 点击复制
    copy(data) {
      copyData(data);
    },
    // 查看轨迹
    trajectoryQuery(row) {
      this.queryTrackParam = row;
      this.showQueryTrack.visible = true;
      this.showQueryTrack.trackKey = new Date().getTime();
    },
    handleClick(row) {
      console.log('运单号：', row.id, row.waybillNumber);
      this.TrackParam = row;
      this.showQueryTrack.trackKey = new Date().getTime();
      this.waybillVisible = true;
    },
    // 列表数据勾选
    selectTable(data) {
      this.selectionList = data;
      const newArray = cloneDeep(data);
      this.downloadArr = newArray.map((item) => {
        if (item.labelUrl === '' || item.labelUrl === null) {
          item.labelUrl = item.serviceLableUrl;
        }
        return item.labelUrl;
      });
    },
    // 全部导出
    allExportOrder() {
      const param = {
        ...this.queryForm.params,
        operator: this.$store.state.user.realName,
        operatorId: this.$store.state.user.id,
        type: 'CSV',
        sourceType: 2
      };
      if (param.numList.length === 0) {
        if (!param.numList01 && !param.numList02) {
          this.$message.warning(this.$t('newOrder.timeIsNotNull'));
          return;
        }
      }
      if (this.searchNumberList.length <= 0 && (!this.timeValue || this.timeValue.length === 0)) {
        this.$message.warning(this.$t('newOrder.timeIsNotNull'));
        return;
      }
      archiveWaybillExportAll(param).then((res) => {
        if (res.code === 200) {
          goRWExportList(this);
        }
      });
    },
    /**
     * 物流订单导出
     */
    async exportOrder() {
      if (this.selectionList.length <= 0) {
        this.$message.warning(this.$t('collectionCenter.PleaseTickTheDataExport'));
        return;
      }
      const waybillNumberList = this.selectionList.map((item) => {
        return item.waybillNumber;
      });
      const param = {
        waybillNumbers: waybillNumberList,
        operator: this.$store.state.user.realName,
        operatorId: this.$store.state.user.id,
        type: 'CSV',
        sourceType: 1
      };
      archiveWaybillExportAll(param).then((res) => {
        if (res.code === 200) {
          goRWExportList(this);
        }
      });
    },
    // 批量导出单号
    orderNumberExport() {
      this.$refs.OrderExport.handleOpen();
    },
    // 导出子包信息
    exportOrderChilder() {
      if (this.searchNumberList.length <= 0 && (!this.timeValue || this.timeValue.length === 0)) {
        this.$message.warning(this.$t('newOrder.timeIsNotNull'));
        return;
      }
      subpackageExportAll(this.SubpackageParam).then((res) => {
        if (res.code === 200) {
          this.$message.success(this.$t('GlobalSetObj.ExportSuccessful1'));
          goRWExportList(this);
        }
      });
    },

    // 操作表头的显示与隐藏
    operationTable() {
      const tableTh = [];
      this.bindTableColumns.forEach((item) => {
        if (this.tableHeaderForm.tableHeaderList.includes(item.label)) {
          tableTh.push(item);
        }
      });
      this.tableHeaderList = tableTh;
      this.isoperationTable = false;
    },
    // 重置
    resetTable() {
      this.tableHeaderForm.tableHeaderList = tableHeaderForm;
      this.tableHeaderList = headerList;
      this.isoperationTable = false;
      window.location.reload();
    },
    // 操作表头弹框
    operationTableDialog() {
      this.isoperationTable = true;
    },
    handleChangeLable(val) {
      const index = val - 1;
      this.searchNameObj = this.selectLabel[index];
    },
    // 重置
    resetForm() {
      this.queryForm.pageNumber = 1;
      this.searchNumberStr = '';
      this.queryForm.params = {
        searchNumberType: '1',
        searchTimeType: '1',
        customerIds: []
      };
      this.getTimer();
      this.searchFun();
    },
    // 获取最近一星期时间
    getTimer() {
      const day = new Date();
      const brazilTime = day.toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' });
      const today = dayjs(brazilTime).format('YYYY-MM-DD');
      // const oneWeekAgo = dayjs(brazilTime).subtract(1, 'week').format('YYYY-MM-DD');
      this.timeValue = [today + ' 00:00:00', today + ' 23:59:59'];
    },
    // 修改时间
    handleTime(val) {
      if (val) {
        const startDate = dayjs(val[0]);
        const endDate = dayjs(val[1]);
        // 计算天数差（取绝对值，确保顺序不影响结果）
        const daysDiff = Math.abs(endDate.diff(startDate, 'day'));
        // 判断是否超过31天
        const isOver31Days = daysDiff > 31;
        if (isOver31Days) {
          this.$message.error(this.$t('tablePrice.timeRangeLimit'));
          this.getTimer();
        } else {
          this.timeValue = [val[0], val[1]];
        }
      } else {
        this.timeValue = [];
      }
    },
    // 查询单号整理
    searchNumberCollation() {
      if (this.searchNumberStr) {
        // 单号格式化，去除空格
        const orderNumber = this.searchNumberStr.split(/[(\r\n)\r\n]+/);
        const numberList = [];
        orderNumber.map((item) => {
          if (item) {
            numberList.push(item.trim());
          }
        });
        this.searchNumberList = numberList;
      } else {
        this.searchNumberList = [];
      }
    },
    changeInput(val) {
      this.$emit('input', val);
    },
    searchFun() {
      this.selectionList = [];
      this.downloadArr = [];
      this.searchNumberCollation();
      if (this.searchNumberList.length > 0) {
        this.timeValue = [];
      }

      let numList = this.searchNumberList;
      if (numList && numList.length > 2000) {
        numList = numList.slice(0, 2000); // 截取前2000个单号
        this.$message.warning(this.$t('newOrder.searchMax1000'));
      }

      const createStartTime = this.timeValue[0];
      const createEndTime = this.timeValue[1];

      if (numList.length === 0) {
        if (!createStartTime && !createEndTime || !this.timeValue) {
          this.$message.warning(this.$t('newOrder.timeIsNotNull'));
          return;
        }
      }

      const queryForm = cloneDeep(this.queryForm);
      const timeParams = [
        'deliveredStartTime', 'deliveredEndTime',
        'receiptStartTime', 'receiptEndTime',
        'sendStartTime', 'sendEndTime',
        'customerSendStartTime', 'customerSendEndTime',
        'dispatchReceiptTimeStartTime', 'dispatchReceiptTimeEndTime',
        'deliveryStartTime', 'deliveryEndTime',
        'lastDeliveryTimeStartTime', 'lastDeliveryTimeEndTime',
        'createStartTime', 'createEndTime'
      ];
      timeParams.forEach(param => {
        this.queryForm.params[param] = '';
        queryForm.params[param] = '';
      });
      if (this.queryForm.params.searchTimeType === '2') {
        this.queryForm.params.deliveredStartTime = createStartTime;
        this.queryForm.params.deliveredEndTime = createEndTime;
        queryForm.params.deliveredStartTime = createStartTime;
        queryForm.params.deliveredEndTime = createEndTime;
      } else if (this.queryForm.params.searchTimeType === '3') {
        this.queryForm.params.receiptStartTime = createStartTime;
        this.queryForm.params.receiptEndTime = createEndTime;
        queryForm.params.receiptStartTime = createStartTime;
        queryForm.params.receiptEndTime = createEndTime;
      } else if (this.queryForm.params.searchTimeType === '4') {
        this.queryForm.params.sendStartTime = createStartTime;
        this.queryForm.params.sendEndTime = createEndTime;
        queryForm.params.sendStartTime = createStartTime;
        queryForm.params.sendEndTime = createEndTime;
      } else if (this.queryForm.params.searchTimeType === '5') {
        this.queryForm.params.customerSendStartTime = createStartTime;
        this.queryForm.params.customerSendEndTime = createEndTime;
        queryForm.params.customerSendStartTime = createStartTime;
        queryForm.params.customerSendEndTime = createEndTime;
      } else if (this.queryForm.params.searchTimeType === '1') {
        this.queryForm.params.createStartTime = createStartTime;
        this.queryForm.params.createEndTime = createEndTime;
        queryForm.params.createStartTime = createStartTime;
        queryForm.params.createEndTime = createEndTime;
      } else if (this.queryForm.params.searchTimeType === '6') {
        this.queryForm.params.dispatchReceiptTimeStartTime = createStartTime;
        this.queryForm.params.dispatchReceiptTimeEndTime = createEndTime;
        queryForm.params.dispatchReceiptTimeStartTime = createStartTime;
        queryForm.params.dispatchReceiptTimeEndTime = createEndTime;
      } else if (this.queryForm.params.searchTimeType === '7') {
        this.queryForm.params.deliveryStartTime = createStartTime;
        this.queryForm.params.deliveryEndTime = createEndTime;
        queryForm.params.deliveryStartTime = createStartTime;
        queryForm.params.deliveryEndTime = createEndTime;
      } else {
        this.queryForm.params.lastDeliveryTimeStartTime = createStartTime;
        this.queryForm.params.lastDeliveryTimeEndTime = createEndTime;
        queryForm.params.lastDeliveryTimeStartTime = createStartTime;
        queryForm.params.lastDeliveryTimeEndTime = createEndTime;
      }
      const numberParams = [
        'customerNumbers', 'waybillNumbers',
        'invoiceNumbers', 'subPackageNumbers', 'scanOrderNumbers',
        'orderNumbers',
        'transitBagNumbers'
      ];
      numberParams.forEach(param => {
        this.queryForm.params[param] = [];
        queryForm.params[param] = [];
      });
      if (this.queryForm.params.searchNumberType === '2') {
        this.queryForm.params.customerNumbers = numList;
        queryForm.params.customerNumbers = numList;
      } else if (this.queryForm.params.searchNumberType === '1') {
        this.queryForm.params.waybillNumbers = numList;
        queryForm.params.waybillNumbers = numList;
      } else if (this.queryForm.params.searchNumberType === '6') {
        this.queryForm.params.invoiceNumbers = numList;
        queryForm.params.invoiceNumbers = numList;
      } else if (this.queryForm.params.searchNumberType === '7') {
        this.queryForm.params.subPackageNumbers = numList;
        queryForm.params.subPackageNumbers = numList;
      } else if (this.queryForm.params.searchNumberType === '8') {
        this.queryForm.params.scanOrderNumbers = numList;
        queryForm.params.scanOrderNumbers = numList;
      } else if (this.queryForm.params.searchNumberType === '15') {
        this.queryForm.params.orderNumbers = numList;
        queryForm.params.orderNumbers = numList;
      } else {
        this.queryForm.params.transitBagNumbers = numList;
        queryForm.params.transitBagNumbers = numList;
      }
      this.queryForm.params.numList = numList;
      this.queryForm.params.numList01 = createStartTime;
      this.queryForm.params.numList02 = createEndTime;
      this.queryForm.params.dataType = this.dataType;
      queryForm.params.numList = numList;
      queryForm.params.numList01 = createStartTime;
      queryForm.params.numList02 = createEndTime;
      queryForm.params.dataType = this.dataType;
      this.SubpackageParam = queryForm;

      const loading = this.$loading({
        fullscreen: true,
        lock: true,
        spinner: 'el-icon-loading',
        text: 'loading...',
        background: 'rgba(250, 250, 250, 0.6)'
      });
      archiveQueryPage(this.queryForm).then((res) => {
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.total = res.data.total;

          this.tableData.map((item) => {
            item['checkTrajectory'] = true;
            // 用于区分页面————这个页面没有备注
            item['isNotePage'] = true;
            if (item.deliveryDistance) {
              item['deliveryDistance'] = item.deliveryDistance + '(km)';
            }
            if (item.cargoType === 0) {
              item['cargoTypeName'] = this.$t('placeOrder.normal01');
            } else if (item.cargoType === 1) {
              item['cargoTypeName'] = this.$t('placeOrder.big01');
            }
            // 根据权限控制收发件人信息的脱敏处理
            const hasPermission = this.$store.getters.button_permissions.includes(
              'field:customer-sensitive-info'
            );
            if (!hasPermission) {
              if (item.receiveName) {
                item.receiveName = commonDesensitize(item.receiveName);
              }
            }
          });
          loading.close();
        }
      }).finally(() => {
        loading.close();
      });
    },
    // 分页
    handleSizeChange() {
      this.queryForm.number = 1;
      this.searchFun();
    },
    handleCurrentChange() {
      this.searchFun();
    }
  }
};
</script>

<style scoped>
.container {
  padding: 10px;
  box-sizing: border-box;
}
.searchBox >>> .selectClass .el-input__inner {
  font-weight: 600 !important;
}
.table_color_class >>> .WaybillNumber {
  color: #606266 !important;
}

.waybill-number-link {
  color: #00A551;
  cursor: pointer;
}
.waybill-number-link:hover {
  color: #12B866;
}
.drawerClass header {
  border-bottom: 1px solid #ccc !important;
  margin-bottom: 0 !important;
  padding: 20px 20px 20px !important;
  box-sizing: border-box;
}
</style>
